export default __webpack_public_path__ + "book_details-edition.512f4bc3.png";